/**
 * The build this bundle came from (021 FR-021).
 *
 * `dev` is what a local build says, and it is a real answer rather than a placeholder: a
 * practitioner running from source is not on a release, and pretending otherwise would be worse
 * than saying so.
 *
 * Overwritten during the image build by `scripts/write-build-id.mjs`, which the Dockerfile runs
 * with the 12-character short SHA CI already computes for the image and chart tags. It is tracked
 * rather than generated-and-ignored so that `ng build` and the type checker work from a clean
 * checkout with no prior step.
 */
export const BUILD_ID = '06986a825b50';
